module.exports = __webpack_public_path__ + "assets/img/trust_9.6d8bf1aa.png";